import Text from 'components/base/Text';
import { StyledSettingBox } from '../SettingsModal.style';
import { ResourceTypeList } from './ResourceTypeList/ResourceTypeList';
import AdditionalTypesSelector from './AdditionalTypesSelector';
import NewCustomFieldInfo from './NewCustomFieldInfo';

const InputsSetting = ({ formInputsSetting }) => {
  return (
    <StyledSettingBox>
      <section>
        <Text color='shuttleGray' size='medium'>
          Select parameters to present the breakdown of your org resource
          allocation:
        </Text>
      </section>
      <ResourceTypeList
        excludedTypes={formInputsSetting.excludedTypes}
        toggleExcludedType={formInputsSetting.toggleExcludedType}
      />
      {formInputsSetting.isAdditionalTypesAdded && <NewCustomFieldInfo />}
      <AdditionalTypesSelector
        additionalTypes={formInputsSetting.additionalTypes}
        setAdditionalTypes={formInputsSetting.setAdditionalTypes}
      />
    </StyledSettingBox>
  );
};

export default InputsSetting;
